import { Component, ElementRef } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { DiagramDatas, BARCOLOR } from '../../diagram/diagram.component';

@Component({
  selector: 'app-alter',
  templateUrl: './alter.component.html',
  styleUrls: ['./alter.component.css']
})
export class AlterComponent {

  public alter;
 
    
  diagramDatas : DiagramDatas;

  diagramDataInits : DiagramDatas = {
      height: 400,
      diagrams: []    
  };
  
  constructor(
    private elementRef: ElementRef,
    private api: ApiService
  ){ 
    this.api.getAlter().then((values) => {
      this.alter = values;
      
      this.diagramDataInits.diagrams.push({
        bars: [
          {
            value: this.alter.ergVersorgungszielAv.value,
            color: BARCOLOR.blue,
            left: "Versorgungsziel"     
          },
          {
            value: this.alter.ergVersorgungslueckeAvInf.value,
            color: BARCOLOR.red,
            right: "Versorgungslücke",
          }           
        ]
      });
      
      this.diagramDatas = Object.assign({}, this.diagramDataInits);
      
    }, (error) => {
      alert( error );
    });
  }
  
}

 



// WEBPACK FOOTER //
// ./src/app/auswertung/alter/alter.component.ts